import { useEffect, useState } from "react";
import { Button } from "@baluu/ui/components/button";
import { CustomerAuthDialog } from "../CustomerAuthDialog/CustomerAuthDialog";
import { useAuthSnapshot, hydrateSession, signOutCustomer } from "~/widgets/lib/auth-client";

export type LoginButtonProps = {
  businessId?: string;
  businessSlug?: string;
  apiUrl?: string;
  widgetBaseUrl?: string;
  theme?: string;
  primaryColor?: string;
  label?: string;
  profileUrl?: string;
};

function openProfileOverlay(p: LoginButtonProps) {
  const el = document.createElement("baluu-profile-overlay");
  const attrs: Record<string, string | undefined> = {
    "business-id": p.businessId, "business-slug": p.businessSlug, "api-url": p.apiUrl,
    "widget-base-url": p.widgetBaseUrl, theme: p.theme, "primary-color": p.primaryColor,
  };
  for (const [k, v] of Object.entries(attrs)) if (v) el.setAttribute(k, v);
  document.body.appendChild(el);
}

export function LoginButton(p: LoginButtonProps) {
  const auth = useAuthSnapshot();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => { void hydrateSession(p.apiUrl, p.businessSlug); }, [p.apiUrl, p.businessSlug]);

  if (auth.status === "authenticated" && auth.user) {
    const first = auth.user.name.split(" ")[0] || auth.user.email;
    return (
      <div className="relative inline-block">
        <Button variant="outline" onClick={() => setMenuOpen((o) => !o)} aria-expanded={menuOpen}>Hi, {first}</Button>
        {menuOpen && (
          <div role="menu" className="absolute right-0 mt-1 min-w-40 rounded-md border bg-background p-1 shadow-md z-50">
            <button role="menuitem" className="w-full rounded px-2 py-1.5 text-left text-sm hover:bg-muted"
              onClick={() => { setMenuOpen(false); if (p.profileUrl) window.location.assign(p.profileUrl); else openProfileOverlay(p); }}>
              My profile
            </button>
            <button role="menuitem" className="w-full rounded px-2 py-1.5 text-left text-sm hover:bg-muted"
              onClick={() => { setMenuOpen(false); void signOutCustomer(p.apiUrl, p.businessSlug); }}>
              Sign out
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <Button onClick={() => setDialogOpen(true)} disabled={auth.status === "unknown"}>{p.label || "Sign in"}</Button>
      <CustomerAuthDialog open={dialogOpen} onOpenChange={setDialogOpen} apiUrl={p.apiUrl}
        businessSlug={p.businessSlug} primaryColor={p.primaryColor} />
    </>
  );
}
